import axios from 'axios';
import authHeader from "@/service/auth-header";

class ReportService {

    async getReportTasksForUser(companyId, userId, startDate, endDate) {
        return await axios.get(`/api/report/tasks/${companyId}/user/${userId}/${startDate}/${endDate}`, {headers: authHeader()})
    }

    async getReportProcessDurationForUser(companyId, userId, startDate, endDate) {
        return await axios.get(`/api/report/tasks/${companyId}/process/user/${userId}/${startDate}/${endDate}`, {headers: authHeader()})
    }

    async getReportTaskPerformanceForUser(companyId, userId, startDate, endDate) {
        return await axios.get(`/api/report/tasks/${companyId}/performance/user/${userId}/${startDate}/${endDate}`, {headers: authHeader()})
    }

    async getFinancialSummary(companyId, startDate, endDate) {
        return await axios.get(`/api/report/financial/summary/${companyId}/${startDate}/${endDate}`, {headers: authHeader()})
    }

    async getTransactionSummary(companyId, startDate, endDate) {
        return await axios.get(`/api/report/financial/transaction/summary/${companyId}/${startDate}/${endDate}`, {headers: authHeader()})
    }

    async getPractitionerTransactionSummary(companyId, startDate, endDate, selectedPractitioner) {
        return await axios.get(`/api/report/financial/transaction/summary/practitioner/${companyId}/${startDate}/${endDate}/${selectedPractitioner}`, {headers: authHeader()})
    }

    async getDetailedTransactionSummary(companyId, startDate, endDate) {
        return await axios.get(`/api/report/financial/transaction/detailed/${companyId}/${startDate}/${endDate}`, {headers: authHeader()})
    }

    async getAppInvPaySummary(companyId, startDate, endDate) {
        return await axios.get(`/api/report/financial/transaction/appinvpay/${companyId}/${startDate}/${endDate}`, {headers: authHeader()})
    }

    async getAppDetailForCompany(companyId, startDate, endDate) {
        return await axios.get(`/api/report/appointment/detail/${companyId}/${startDate}/${endDate}`, {headers: authHeader()})
    }

}

export default new ReportService();
